import * as React from "react";
import "../../billing/account/create/responsive.css";
import { LayerExternalId } from "./layers/externalId";
import { AccountCreateForm } from "./createForm";
import { LayerCaptureCookie } from "./layers/captureCooke";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { v4 as uuidv4 } from "uuid";
import { formActions } from "../../../store/formSlice";
import { useAppDispatch } from "../../../store/hooks";
import { getDefaultBillingAccountCreateInput } from "../utils";
import { CpFormContext } from "../../../components/form/CpFormContext";

const stripePromise: Promise<Stripe | null> = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY as string);

export const AccountCreate: React.FC = () => {
  const dispatch = useAppDispatch();
  const formIdRef = React.useRef(uuidv4());

  const [isInitialized, setIsInitialized] = React.useState(false);

  React.useEffect(() => {
    initialize();
  }, []);

  function initialize() {
    dispatch(formActions.setInitialValues({ id: formIdRef.current, values: getDefaultBillingAccountCreateInput() }));
    setIsInitialized(true);
  }

  if (!isInitialized) {
    return null;
  }

  return (
    <CpFormContext.Provider value={{ submit: () => Promise.resolve(), id: formIdRef.current }}>
      <LayerCaptureCookie>
        <LayerExternalId>
          <AccountCreateForm stripePromise={stripePromise} />
        </LayerExternalId>
      </LayerCaptureCookie>
    </CpFormContext.Provider>
  );
};
